import ActionType from './action-type'
import * as Actions from './actions'
import {type ThunkAction} from 'redux-thunk'
import {REST} from '../../../api'
import {type AppState} from '../../types/app-state'
import {Api} from '../../../api/Api'

const NODES_URL = '/api/v1/nodeWatch'

const setError = (error: string): Actions.SetError => ({
    type: ActionType.SET_ERROR,
    payload: error,
})

const setLoading = (): Actions.SetLoading => ({
    type: ActionType.SET_LOADING,
})

const setWatchedNodes = (nodes: string[]): Actions.SetWatchedNodes => ({
    type: ActionType.SET_WATCHED_NODES,
    payload: nodes,
})

export const fetchWatchedNodes = (): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(setLoading())
        REST.get(NODES_URL)
            .then((response) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setWatchedNodes(response.data))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable, @typescript-eslint/no-unsafe-argument
            .catch((err) => dispatch(setError(err)))
    }
}

export const addNodeToWatchList = (
    node: string,
): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(setLoading())
        REST.post(`${NODES_URL}/${node}`)
            .then(() => {
                dispatch(fetchWatchedNodes())
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((err) => {
                dispatch(fetchWatchedNodes())
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setError(err))
            })
    }
}

export const deleteNodeFromWatchList = (
    node: string,
): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(setLoading())
        REST.delete(`${NODES_URL}/${node}`)
            .then(() => {
                dispatch(fetchWatchedNodes())
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((err) => {
                dispatch(fetchWatchedNodes())
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setError(err))
            })
    }
}
